export default __webpack_public_path__ + "static/media/bedroom2.c5f51355.wav";